import { DatePipe, Time } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Job } from '../../../../Jobbing/models/Job';
import { JobbingService } from '../../../../Jobbing/jobbing.service';
import { Equipment } from '../../../../Jobbing/models/Equipment';
import { JobServicePromise } from '../../../../Jobbing/models/JobServicePromise';

@Component({
  selector: 'app-job-detail-box',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './job-detail-box.component.html',
  styleUrl: './job-detail-box.component.scss'
})
export class JobDetailBoxComponent {

  @Input()
  jobDetails?: Job;

  constructor(private jobbingService: JobbingService) { }

  getJobPriority(): string {
    if (this.jobDetails) {
      const movement = this.jobbingService.getCurrentMovement(this.jobDetails.movements);
      return movement.jobPriority.name;
    } else {
      return "";
    }
  }

  getJobEquipments(): string {
    if (this.jobDetails && this.jobDetails.jobEquipments) {
      const jobEquipmentString = this.jobDetails.jobEquipments.map((equipment: Equipment) => equipment.name).join(", ")
      return jobEquipmentString;
    } else {
      return "";
    }
  }

  getServicePromise(servicePromise: JobServicePromise, timeValue: Time | null): string {
    return this.jobbingService.getServicePromise(servicePromise, timeValue);
  }

  getEstimatedTime(): string {
    if (this.jobDetails) {
      return this.jobbingService.getDurationString(this.jobDetails.estimatedHours)
    }
    return "";
  }
}
